function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/button-has-type */
import { safeSelect } from '@sie/web-common-utils';
import PropTypes from 'prop-types';
import React, { Children, createRef } from 'react';
import AbstractInput from '../AbstractInput';
import Icon from '../Icon';
import WaitIndicator from '../WaitIndicator';
import { classNamesFor } from '../utils/classNames';
import filterA11YProps from '../utils/filterA11YProps';

var hasIcon = function hasIcon(children) {
  return Children.toArray(children).reduce(function (acc, cur) {
    if (acc) return acc;
    if (safeSelect(cur, 'type') === Icon) return true;
    return acc;
  }, false);
};
/**
 * The Button component behaves just like a button element but with SIE specific
 * style hooks
 *
 * - [MDN docs on button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button)
 */


var Button = /*#__PURE__*/function (_AbstractInput) {
  _inherits(Button, _AbstractInput);

  var _super = _createSuper(Button);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props = _this.props,
          pending = _this$props.pending,
          onClick = _this$props.onClick,
          ariaDisabled = _this$props.ariaDisabled;
      var ogTarget = safeSelect(event, 'target');

      if (pending || ariaDisabled) {
        event.preventDefault();
        event.stopPropagation();
      } else {
        onClick(_objectSpread(_objectSpread({}, event), {}, {
          target: safeSelect(_this._getRef(), 'current'),
          originalTarget: ogTarget
        }));
      }
    });

    _this._node = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(Button, [{
    key: "_getRef",
    value: function _getRef() {
      var node = this.props.node;
      return node || this._node;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          role = _this$props2.role,
          ariaLabel = _this$props2.ariaLabel,
          ariaHaspopup = _this$props2.ariaHaspopup,
          ariaExpanded = _this$props2.ariaExpanded,
          ariaDisabled = _this$props2.ariaDisabled,
          tabindex = _this$props2.tabindex,
          qa = _this$props2.qa,
          id = _this$props2.id,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          name = _this$props2.name,
          type = _this$props2.type,
          variant = _this$props2.variant,
          ctaType = _this$props2.ctaType,
          size = _this$props2.size,
          value = _this$props2.value,
          onKeyDown = _this$props2.onKeyDown,
          onMouseEnter = _this$props2.onMouseEnter,
          onMouseLeave = _this$props2.onMouseLeave,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          children = _this$props2.children,
          iconOnly = _this$props2.iconOnly,
          node = _this$props2.node,
          active = _this$props2.active,
          pending = _this$props2.pending,
          dataTrack = _this$props2.dataTrack,
          dataTrackClick = _this$props2.dataTrackClick,
          dataTelemetryMeta = _this$props2.dataTelemetryMeta,
          trackClick = _this$props2.trackClick,
          telemetryMeta = _this$props2.telemetryMeta,
          a11yProps = _objectWithoutProperties(_this$props2, ["role", "ariaLabel", "ariaHaspopup", "ariaExpanded", "ariaDisabled", "tabindex", "qa", "id", "className", "disabled", "name", "type", "variant", "ctaType", "size", "value", "onKeyDown", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "children", "iconOnly", "node", "active", "pending", "dataTrack", "dataTrackClick", "dataTelemetryMeta", "trackClick", "telemetryMeta"]);

      var applyPendingTreatment = /^solid$/i.test(variant) && pending;

      var _Button$getClassName = Button.getClassName({
        className: className,
        variant: variant,
        ctaType: ctaType,
        size: size,
        disabled: disabled || ariaDisabled,
        iconOnly: iconOnly,
        active: active,
        pending: pending,
        applyPendingTreatment: applyPendingTreatment,
        hasIconChild: hasIcon(children)
      }),
          root = _Button$getClassName.root,
          contents = _Button$getClassName.contents;

      return /*#__PURE__*/React.createElement("button", _extends({}, filterA11YProps(a11yProps), {
        "data-qa": qa,
        "data-track": dataTrack,
        "data-track-click": trackClick || dataTrackClick,
        "data-telemetry-meta": telemetryMeta || dataTelemetryMeta,
        ref: this._getRef(),
        id: id,
        className: root
      }, tabindex !== null && tabindex !== undefined && {
        tabIndex: tabindex
      }, role !== null && role !== undefined && {
        role: role
      }, {
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        "aria-disabled": ariaDisabled,
        type: type,
        name: name,
        value: value,
        onClick: this._onClick,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled
      }), variant !== 'content' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: contents
      }, children), applyPendingTreatment && /*#__PURE__*/React.createElement(WaitIndicator, {
        className: "psw-l-center"
      })), variant === 'content' && children);
    }
  }]);

  return Button;
}(AbstractInput);

var cx = classNamesFor(Button);
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for Button
 */

Button.getClassName = function (_ref) {
  var className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
      _ref$ctaType = _ref.ctaType,
      ctaType = _ref$ctaType === void 0 ? 'primary' : _ref$ctaType,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      isFocused = _ref.isFocused,
      disabled = _ref.disabled,
      iconOnly = _ref.iconOnly,
      active = _ref.active,
      pending = _ref.pending,
      applyPendingTreatment = _ref.applyPendingTreatment,
      hasIconChild = _ref.hasIconChild;
  var ctaTypeSegment = ctaType ? "".concat(ctaType, "-") : '';
  var classVariantSegment = "".concat(variant, "-");
  return {
    root: cx(className, 'psw-button', 'psw-b-0', {
      'psw-is-pending': pending
    }, {
      'psw-is-disabled': disabled
    }, {
      'psw-is-focused': isFocused
    }, {
      'psw-is-active': active
    }, _defineProperty({}, cx('psw-t-button', 'psw-l-line-center', 'psw-button-sizing', "psw-button-sizing--".concat(size), {
      'psw-button-sizing--icon-only': iconOnly || variant === 'quick-action'
    }), variant === 'solid' || variant === 'quick-action'), _defineProperty({}, "psw-".concat(ctaTypeSegment, "button"), ctaType && (variant === 'solid' || variant === 'quick-action')), _defineProperty({}, "psw-".concat(classVariantSegment, "button"), variant), _defineProperty({}, cx('psw-option-button', 'psw-r-1', 'psw-ally-indicator', 'psw-ally-indicator-gap-0', 'psw-ally-indicator-inset'), variant === 'option'), _defineProperty({}, cx('psw-toggle-button', 'psw-r-2', 'psw-b-1', 'psw-ally-indicator', 'psw-ally-indicator-gap-1'), variant === 'toggle'), {
      'psw-border-b-l': variant === 'tab'
    }, {
      'psw-with-icon': hasIconChild
    }, _defineProperty({}, cx('psw-p-x-3', 'psw-r-pill', 'psw-l-line-center', 'psw-l-inline', 'psw-t-size-3', 'psw-t-align-c'), variant === 'page'), _defineProperty({}, cx('psw-c-t-accent', 'psw-c-t-interactive-1'), /link/.test(variant)), _defineProperty({}, cx('psw-standard-link', 'psw-t-link', 'psw-c-t-accent', 'psw-c-t-interactive-1'), variant === 'link'), _defineProperty({}, cx('psw-inline-link', 'psw-t-inline-link'), variant === 'inline-link')),
    contents: cx('psw-fill-x', {
      'psw-l-line-center': iconOnly || variant === 'quick-action',
      'psw-t-truncate-1 psw-l-space-x-2': !iconOnly && variant === 'solid'
    }, _defineProperty({}, cx({
      'psw-fade-out': applyPendingTreatment
    }), variant !== 'content'))
  };
};
/**
 * Defines aliases for classNames used by this component
 */


Button.useClassNames = function (classNames) {
  Button.classNames = classNames;
};

Button.defaultProps = {
  qa: '',
  id: '',
  variant: 'solid',
  size: 'medium',
  ctaType: null,
  role: null,
  ariaLabel: null,
  disabled: false,
  type: 'button',
  name: '',
  value: '',
  tabindex: null,
  active: false,
  pending: false,
  ariaHaspopup: null,
  ariaExpanded: null,
  ariaDisabled: false,
  className: '',
  iconOnly: false,
  node: null,
  dataTrack: null,
  dataTrackClick: null,
  dataTelemetryMeta: null,
  trackClick: null,
  telemetryMeta: null,
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onKeyDown: function onKeyDown() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {}
};
Button.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * The unique identifier for the button element
   */
  id: PropTypes.string,

  /**
   * Presentational variant to apply
   * **Deprecations: will be removed in v1**
   * - outline should no longer be used
   * - option should no longer be used
   */
  variant: PropTypes.oneOf(['solid', 'quick-action', 'content', 'outline', 'option', 'toggle', 'page', 'link']),

  /**
   * The size of the quick action button
   * **Deprecations: will be removed in v1**
   * - large
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The type of button in design language, generally affects button color
   * **Deprecations** the below values should be avoided
   * - primary-1,
   * - primary-2,
   * - secondary-1,
   * - secondary-2,
   * - secondary-3,
   * - secondary-4,
   * - utility,
   * - alt-secondary,
   * - purchase,
   */
  ctaType: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'commerce', 'primary-1', 'primary-2', 'secondary-1', 'secondary-2', 'secondary-3', 'secondary-4', 'utility', 'alt-secondary', 'purchase']),

  /**
   * Button with icon only.
   */
  iconOnly: PropTypes.bool,

  /**
   * Allows custom roles which may be useful to add in different contexts. By default
   * no role is set because the button element receives the role button by default
   */
  role: PropTypes.oneOf([undefined, null, 'menuitemradio', 'menuitem']),

  /**
   * Aria label for button. Be aware that screen reader will always use this value if provided
   */
  ariaLabel: PropTypes.string,

  /**
   * Aria annotation to let screen readers know that the button opens another UI often a menu
   */
  ariaHaspopup: PropTypes.bool,

  /**
   * Aria annotation to let screen readers know that the UI controlled by the button is open or
   * expanded
   */
  ariaExpanded: PropTypes.bool,

  /**
   * Aria annotation to let screen readers know that the UI controlled by the button is perceivable
   * but disabled, so it is not editable or otherwise operable.
   * When enabled, button will appear disabled and will not respond to click events,
   * however button can still be focused and interacted with by accessibility tools
   */
  ariaDisabled: PropTypes.bool,

  /**
   * Whether or not the button is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Override to allow custom tab focus ordering. This should rarely be altered and the source
   * order should determine focus handling
   */
  tabindex: PropTypes.number,

  /**
   * The html5 attribute
   */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),

  /**
   * The name of the button, which is submitted as a pair with the button’s value as part
   * of the form data.
   */
  name: PropTypes.string,

  /**
   * The initial value of the button. It defines the value associated with the button’s name
   * when it’s submitted with the form data. This value is passed to the server in params when the
   * form is submitted.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Whether the button is in the active state. For example the button is a toggle
   * and clicking it once activates the button.
   */
  active: PropTypes.bool,

  /**
   * Whether the button is in the pending state waiting for the result of interacting with it
   */
  pending: PropTypes.bool,

  /**
   * event callback to be called when a user clicks on the button or children within
   */
  onClick: PropTypes.func,

  /**
   * event callback to be called when a key press occurs
   */
  onKeyDown: PropTypes.func,

  /**
   * event callback to be called when a users mouse enters the button or children within
   */
  onMouseEnter: PropTypes.func,

  /**
   * event callback to be called when a users mouse leaves the button or children within
   */
  onMouseLeave: PropTypes.func,

  /**
   * event callback to be called when the button is focused
   */
  onFocus: PropTypes.func,

  /**
   * event callback to be called when the button loses focus
   */
  onBlur: PropTypes.func,

  /**
   * children to be rendered within the button. This is often a label but can be a label and
   * an icon. A button may also wrap any content to "Buttonify" it
   */
  children: PropTypes.node.isRequired,

  /**
   * forwarded ref to attach to the button element
   */
  node: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * Data attribute read by PDC data layer when user clicks on the button
   */
  dataTrack: PropTypes.string,

  /**
   * **DEPRECATED** use `trackClick` prop instead
   * Data attribute read by web-common-telemetry to tag this element for tracking
   * interactions
   */
  dataTrackClick: PropTypes.string,

  /**
   * **DEPRECATED** use `telemetryMeta` prop instead
   * Data attribute read by web-common-telemetry to add any meta data to be sent to the
   * spec factories
   */
  dataTelemetryMeta: PropTypes.string,

  /**
   * The spec id identifying the interaction
   */
  trackClick: PropTypes.string,

  /**
  * Serialized json data of context specific telemetry data
  */
  telemetryMeta: PropTypes.string
};
export default Button;